import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { RingLoader } from "react-spinners";

const generateOptions = (linechartLebels, month) => ({
  chart: { toolbar: { show: false } },
  tooltip: { theme: "dark" },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth" },
  xaxis: {
    type: month ? "datetime" : "category",
    categories: linechartLebels || [],
    labels: { style: { colors: "#c8cfca", fontSize: "12px" } },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    labels: { style: { colors: "#c8cfca", fontSize: "12px" } },
  },
  legend: { show: false },
  grid: { strokeDashArray: 5, borderColor: "#56577A" },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0,
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [],
    },
    colors: ["#2CD9FF", "#582CFF"],
  },
  colors: ["#2CD9FF", "#582CFF"],
});

const LineChart = ({ lineChartData, lineChartLebels, month = true }) => {
  const [chartData, setChartData] = useState(lineChartData || []);
  const [chartOptions, setChartOptions] = useState(
    generateOptions(lineChartLebels, month)
  );

  // Update chart data and options when props change
  useEffect(() => {
    setChartData(lineChartData || []);
    setChartOptions(generateOptions(lineChartLebels, month));
  }, [lineChartData, lineChartLebels, month]);

  if (!chartData || chartData.length === 0 || !chartOptions) {
    return (
      <div
        style={{
          color: "white",
          fontSize: "20px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <RingLoader size={200} loading={true} color='#0099a2' />
      </div>
    );
  }

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartData}
      type='area'
      width='100%'
      height='100%'
    />
  );
};

export default LineChart;
